export default "__VITE_ASSET__DiuoRca1__"